import { homepagePrizeCarouselItems } from 'constants/Prizes';
import { SharedPrizeCarousel } from 'components/prize-carousel/SharedPrizeCarousel';

export const PrizeCarousel = () => {
  return (
    <SharedPrizeCarousel
      items={homepagePrizeCarouselItems}
      textPosition="default"
      overlayVariant="gradient"
      showButtonsOnMobile={false}
      showButtonsOnDesktop={true}
      desktopInlinePadding="40px"
      slidePadding="var(--dm2025-gap-8)"
      linkBuilder={(item) =>
        item.slug ? `/prizes/details/${item.slug}` : null
      }
    />
  );
};
